<script>
export default {
  name: 'ExpandedTextarea',

  mounted () {
    this.init()
    this.$el.nextElementSibling.addEventListener('input', this.resizeTextarea)
  },

  beforeUnmount () {
    this.$el.nextElementSibling.removeEventListener('input', this.resizeTextarea)
  },

  methods: {
    init () {
      if (this.$el.nextElementSibling.scrollHeight > 75) {
        this.$el.nextElementSibling.style.height = '100px'
      } else if (this.$el.nextElementSibling.scrollHeight < 25) {
        this.$el.nextElementSibling.style.height = '25px'
      } else {
        this.$el.nextElementSibling.style.height = (this.$el.nextElementSibling.scrollHeight) + 'px'
      }
    },

    resizeTextarea (event) {
      if (parseInt(event.target.style.height) > 75) {
        event.target.style.height = '100px'
        return
      }

      event.target.style.height = 'auto'
      event.target.style.height = (event.target.scrollHeight) + 'px'
    }
  },

  render () {
    return this.$slots && this.$slots.default && this.$slots.default()
  }
}
</script>
